export const switchCase = (val, type = 1) => { // type = 1表示转大写（toUpperCase） type = 0 转小写（toLowerCase）
  if (val.length > 0) {
    return type === 1 ? val.toUpperCase() : val.toLowerCase()
  } else {
    return val
  }
}

export const toFixed = (val, n = 2, isAll = false) => { // isAll 是否支持格式所有数据 n 小数点位置
  if (isAll) {
    if (Math.abs(val) > 0) {
      return val.toFixed(n)
    } else {
      return val
    }
  } else {
    return val > 0 ? val.toFixed(n) : '0.00'
  }
}

export const strEncryption = (val, n = 1) => { // 字符串前后加密 n前后显示字符串个数
  var l = val.length
  if (l < 2) {
    return val + '****'
  } else {
    return val.substr(0, n) + '****' + val.substr(l - n, l)
  }
}

export function EuropeStatusStr(type) {
  let S = "";
  switch (type) {
    case '1':
      return "-";
    case '2':
      return "+";
    case '3':
      return "+";
    case '4':
        return "+";
    default:
      return "其他";
  }
  return S;
}
export function moneyFilter(cost) {
  var money = Number(cost).toFixed(2).split(".");
  money[0] = money[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return money.join(".");
}





// WEBPACK FOOTER //
// ./src/common/filter/index.js